module.exports = __webpack_public_path__ + "img/korea-map-watermark.b17d5b2.webp";